import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

const localKiosk = ["127.0.0.1", "localhost"].includes(location.hostname) && location.port === "8787";
if ("serviceWorker" in navigator && import.meta.env.PROD && !localKiosk) {
  window.addEventListener("load", () => {
    let reloading = false;
    const release = "v41";
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloading || sessionStorage.getItem("walter-sw-refresh") === release) return;
      reloading = true;
      sessionStorage.setItem("walter-sw-refresh", release);
      location.reload();
    });
    navigator.serviceWorker.register("/sw.js").then((registration) => registration.update()).catch(() => undefined);
  });
}
